import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

export const imageUrl = (id, variant = "card") => `${API}/product-images/${id}/${variant}.webp`;

export function withAuth(getToken) {
  return async (config = {}) => {
    const token = await getToken();
    return {
      ...config,
      headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` },
    };
  };
}
